<template>
  <v-card
    width="330px"
  >
    <v-container
      fluid
      class="image-container ma-0 pa-0"
    >
      <v-row
        align="center"
        justify="center"
        class="grey lighten-4 ma-0 fill-height"
      >
        <v-icon color="red">mdi-folder-search</v-icon>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    name: "ProcessingCardDragGhost",
  }
</script>

<style scoped lang="scss">
  .image-container {
    height: 360px !important;
  }

  .v-icon {
    font-size: 180px !important;
    margin: 0 auto;
    color: var(--v-accent-base);
  }
</style>
